module.exports = __webpack_public_path__ + "static/media/sprint.dc53bb08.jpg";